module.exports = __webpack_public_path__ + "static/img/3.14a309b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/1/eng/3.png
// module id = 8ZGw
// module chunks = 0